import gsap from 'gsap';
import YMAP_STYLES from '../../assets/scripts/customization.json';
import Order from './order';
import Utils from '../../assets/scripts/utils/utils';

const ClassName = {
	DISABLED: '_disabled',
};

class OrderDelivery {
	constructor() {
		this.init();
	}

	init() {
		this.container = document.querySelector('[data-delivery]');

		if (!this.container || this.container.inited) {
			return;
		}

		this.form = this.container.closest('form');

		this._initDeliveryList();
		this._initCdekPoint();
		this._initCdekCourier();
		this._initStoreMap();

		this.container.inited = true;
	}

	_initDeliveryList() {
		const deliveryList = this.container.querySelector('.order-delivery__list');

		if (!deliveryList) {
			return;
		}

		const countrySelect = this.container.querySelector('[data-select="country"]').customSelect;
		const cityInput = this.container.querySelector('.order-delivery__city input');
		const cityOptionsList = this.container.querySelector('.order-delivery__city .input__hints');
		const deliveryRadios = deliveryList.querySelectorAll('input[type="radio"]');
		const allDeliveryRadio = deliveryList.querySelector('._all input[type="radio"]');

		const itemContents = Array.from(this.container.querySelectorAll('.order-delivery__item-content'));
		const offlinePayment = document.querySelector('.order-payment__method._offline');

		this.cityInput = cityInput;
		this.deliveryList = deliveryList;

		const chekIfCitySPB = () => {
			const isSpb = cityInput.value === 'Санкт-Петербург';

			this.container.classList.toggle('_spb', isSpb);

			deliveryRadios.forEach((radio) => {
				radio.checked = false;
			});

			if (!isSpb) {
				allDeliveryRadio.checked = true;
				allDeliveryRadio.dispatchEvent(new Event('change'));
			} else {
				deliveryRadios[0].checked = true;
				deliveryRadios[0].dispatchEvent(new Event('change'));
			}

			this.openDeliveryList();
		};

		if (!cityInput.value.length) {
			cityInput.focus();
		}

		countrySelect.container.addEventListener('custom-select:open', () => {
			deliveryList.classList.add(ClassName.DISABLED);
		});
		countrySelect.container.addEventListener('custom-select:close', () => {
			deliveryList.classList.remove(ClassName.DISABLED);
		});
		countrySelect.select.addEventListener('change', () => {
			cityInput.customInput.setValue('');
		});
		cityInput.addEventListener('hints:open', () => {
			deliveryList.classList.add(ClassName.DISABLED);
		});
		cityInput.addEventListener('hints:close', () => {
			deliveryList.classList.remove(ClassName.DISABLED);
		});
		cityInput.addEventListener('input', () => {
			this.closeDeliveryList();
		});
		cityInput.addEventListener('change', () => {
			this.resetCdekPoint();
			this.resetCdekCourier();
		});
		cityOptionsList.addEventListener('click', (e) => {
			const value = e.target.closest('li').getAttribute('data-input-hint-value');

			if (value) {
				chekIfCitySPB();
			}
		});

		const animateItemContent = (name) => {
			const target = this.container.querySelector(`[data-delivery-item-content="${name}"]`);

			if (!target) return;

			itemContents.forEach((el) => {
				if (el === target) return;
				gsap.to(el, {
					height: 0,
					autoAlpha: 0,
					onStart: () => {
						gsap.set(el, { overflow: 'hidden' });
					},
				});
			});

			gsap.to(target, {
				height: 'auto',
				autoAlpha: 1,
				duration: 0.25,
				ease: 'none',
				onStart: () => {
					gsap.set(target, { overflow: 'hidden' });
				},
				onComplete: () => {
					gsap.set(target, { overflow: null });
				},
			});
		};

		deliveryRadios.forEach((radio) => {
			const itemName = radio.getAttribute('data-delivery-item');

			offlinePayment.classList.toggle('_hidden', itemName !== 'store' && radio.checked);

			radio.addEventListener('change', () => {
				this.container.setAttribute('data-delivery', itemName);
				animateItemContent(itemName);

				offlinePayment.classList.toggle('_hidden', itemName !== 'store' && radio.checked);
			});
		});

		const initiallyChecked = Array.from(deliveryRadios).find((r) => r.checked);
		if (initiallyChecked) {
			const initialName = initiallyChecked.getAttribute('data-delivery-item');
			itemContents.forEach((el) => {
				if (el.getAttribute('data-delivery-item-content') === initialName) {
					gsap.set(el, { height: 'auto', autoAlpha: 1, overflow: null });
				} else {
					gsap.set(el, { height: 0, autoAlpha: 0, overflow: 'hidden' });
				}
			});
		}
	}

	_initCdekPoint() {
		const cdekPointOpener = this.container.querySelector('.order-delivery__item._cdek-point .delivery-item__button');
		const cdekPointValue = this.container.querySelector('.order-delivery__item._cdek-point .delivery-item__value');

		if (!cdekPointValue || !cdekPointOpener) {
			return;
		}
		const cdekPointTime = this.container.querySelector('.order-delivery__item._cdek-point .delivery-item__time');
		const cdekPointPrice = this.container.querySelector('.order-delivery__item._cdek-point .delivery-item__info');
		const cdekPointValueText = cdekPointValue.querySelector('span');
		this.cdekPointInputAddress = this.container.querySelector(
			'[data-delivery-item-content="cdek-point"] input#cdek-point-address',
		);
		this.cdekPointInputTime = this.container.querySelector(
			'[data-delivery-item-content="cdek-point"] input#cdek-point-time',
		);
		this.cdekPointInputPrice = this.container.querySelector(
			'[data-delivery-item-content="cdek-point"] input#cdek-point-price',
		);

		this.cdekPointInputAddress.addEventListener('change', () => {
			const address = this.cdekPointInputAddress.value;

			if (address) {
				this.updateCard(address, 'cdek-point');
				cdekPointValueText.textContent = address;
				cdekPointOpener.hidden = true;
				cdekPointValue.hidden = false;
			} else {
				cdekPointOpener.hidden = false;
				cdekPointValue.hidden = true;
				this.updateCard('', 'cdek-point');
				cdekPointValueText.textContent = '';
			}
		});

		this.cdekPointInputPrice.addEventListener('change', () => {
			const address = this.cdekPointInputAddress.value;
			const price = this.cdekPointInputPrice.value;

			if (price) {
				this.updateCard(address, 'cdek-point', price);
				cdekPointPrice.textContent = price;
			}
		});

		this.cdekPointInputTime.addEventListener('change', () => {
			const address = this.cdekPointInputAddress.value;
			const price = this.cdekPointInputPrice.value;
			const time = this.cdekPointInputTime.value;

			if (time) {
				this.updateCard(address, 'cdek-point', price, time);
				cdekPointTime.textContent = time;
			}
		});
	}

	_initCdekCourier() {
		this.cdekCourierAddress = {
			street: '',
			appartment: '',
			floor: '',
			entrance: '',
			intercom: '',
		};

		const address = this.cdekCourierAddress;
		const container = this.container.querySelector('[data-delivery-item-content="courier-cdek"]');

		if (!container) {
			return;
		}
		const fullAddressInput = container.querySelector('#courier-cdek-address');
		const inputs = {
			street: container.querySelector('#delivery-address'),
			appartment: container.querySelector('#delivery-appartment'),
			floor: container.querySelector('#delivery-floor'),
			entrance: container.querySelector('#delivery-entrance'),
			intercom: container.querySelector('#delivery-intercom'),
		};
		this.cdekCourierInputs = inputs;

		const updateAddress = () => {
			const street = address.street;
			const appartment = address.appartment ? `, кв.${address.appartment}` : '';
			const floor = address.floor ? `, этаж ${address.floor}` : '';
			const entrance = address.entrance ? `, подъезд ${address.entrance}` : '';
			const intercom = address.intercom ? `, домофон ${address.intercom}` : '';

			const fullAddress = `${street}${appartment}${floor}${entrance}${intercom}`;

			fullAddressInput.value = fullAddress;
			this.updateCard(fullAddress, 'courier-cdek');
		};

		inputs.street.addEventListener('change', () => {
			address.street = inputs.street.value;

			updateAddress();
		});

		inputs.street.addEventListener('input', () => {
			address.street = inputs.street.value;
		});

		inputs.appartment.addEventListener('change', () => {
			address.appartment = inputs.appartment.value;

			updateAddress();
		});

		inputs.appartment.addEventListener('input', () => {
			address.appartment = inputs.appartment.value;
		});

		inputs.floor.addEventListener('change', () => {
			address.floor = inputs.floor.value;

			updateAddress();
		});

		inputs.floor.addEventListener('input', () => {
			address.floor = inputs.floor.value;
		});

		inputs.entrance.addEventListener('change', () => {
			address.entrance = inputs.entrance.value;

			updateAddress();
		});

		inputs.entrance.addEventListener('input', () => {
			address.entrance = inputs.entrance.value;
		});

		inputs.intercom.addEventListener('change', () => {
			address.intercom = inputs.intercom.value;

			updateAddress();
		});

		inputs.intercom.addEventListener('input', () => {
			address.intercom = inputs.intercom.value;
		});
	}

	async _initStoreMap() {
		const container = document.getElementById('delivery-store-map');

		if (!container) {
			return;
		}

		await ymaps3.ready;

		const { YMap, YMapDefaultSchemeLayer, YMapDefaultFeaturesLayer, YMapMarker } = ymaps3;

		const center = [Number(container.getAttribute('data-lat')), Number(container.getAttribute('data-lng'))];

		const map = new YMap(container, {
			location: {
				center,
				zoom: 17,
			},
		});

		map.addChild(
			new YMapDefaultSchemeLayer({
				customization: YMAP_STYLES,
			}),
		);

		map.addChild(new YMapDefaultFeaturesLayer());

		const el = document.createElement('img');
		el.className = 'ritm-pin';
		el.src = '/assets/images/map-pin.svg';

		const marker = new YMapMarker({ coordinates: center }, el);
		map.addChild(marker);
	}

	setCdekPoint(address, time, price) {
		this.cdekPointInputAddress.value = address;
		this.cdekPointInputTime.value = time;
		this.cdekPointInputPrice.value = price;
		this.cdekPointInputAddress.dispatchEvent(new Event('change'));
		this.cdekPointInputTime.dispatchEvent(new Event('change'));
		this.cdekPointInputPrice.dispatchEvent(new Event('change'));
	}

	resetCdekPoint() {
		this.cdekPointInputAddress.value = '';
		this.cdekPointInputTime.value = this.cdekPointInputTime.getAttribute('data-input-default') || '';
		this.cdekPointInputPrice.value = this.cdekPointInputPrice.getAttribute('data-input-default') || '';
		this.cdekPointInputAddress.dispatchEvent(new Event('change'));
		this.cdekPointInputTime.dispatchEvent(new Event('change'));
		this.cdekPointInputPrice.dispatchEvent(new Event('change'));
	}

	resetCdekCourier() {
		this.cdekCourierAddress = {
			street: '',
			appartment: '',
			floor: '',
			entrance: '',
			intercom: '',
		};
		this.cdekCourierInputs.street.customInput.setValue('');
		this.cdekCourierInputs.appartment.customInput.setValue('');
		this.cdekCourierInputs.floor.customInput.setValue('');
		this.cdekCourierInputs.entrance.customInput.setValue('');
		this.cdekCourierInputs.intercom.customInput.setValue('');
	}

	updateCard(address = '', name = '', price = '', time = '') {
		const cards = this.container.querySelectorAll('.order-section__card');

		if (!cards.length) return;

		cards.forEach((card) => {
			if (card.classList.contains('_store') || card.classList.contains('_courier-today')) {
				return;
			}

			if (card.classList.contains(`_${name}`)) {
				card.querySelector('.checkout-card__title').textContent = address;
			}

			if (name === 'cdek-point' && price) {
				card.querySelector('.checkout-card__info span:nth-of-type(2)').textContent = price;
			}

			if (name === 'cdek-point' && time) {
				card.querySelector('.checkout-card__info span:nth-of-type(1)').textContent = time;
			}
		});
	}

	openDeliveryList() {
		const deliveryWrapper = this.container.querySelector('.order-delivery__wrapper');

		gsap.to(deliveryWrapper, {
			height: 'auto',
			onStart: () => {
				deliveryWrapper.classList.add('_active');
			},
		});
	}

	closeDeliveryList() {
		const deliveryWrapper = this.container.querySelector('.order-delivery__wrapper');

		gsap.to(deliveryWrapper, {
			height: 0,
			onStart: () => {
				deliveryWrapper.classList.remove('_active');
			},
		});
	}
}

export default new OrderDelivery();
